/**
 * Toggle — 스위치 토글 컴포넌트
 *
 * 체크 상태를 시각적으로 표현하는 스위치. 레이블을 선택적으로 표시할 수 있다.
 */

import { cn } from './cn'
import styles from './Toggle.module.css'

interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  size?: 'sm' | 'md'
  disabled?: boolean
  label?: string
  /** 시각적 label이 없을 때 스크린리더용 설명 */
  'aria-label'?: string
  className?: string
}

export function Toggle({
  checked,
  onChange,
  size = 'md',
  disabled = false,
  label,
  'aria-label': ariaLabel,
  className,
}: ToggleProps) {
  const button = (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={cn(
        styles.root,
        styles[size],
        checked && styles.checked,
        disabled && styles.disabled,
      )}
      onClick={() => !disabled && onChange(!checked)}
    >
      <span className={styles.track}>
        <span className={styles.handle} />
      </span>
    </button>
  )

  if (label) {
    return (
      <label className={cn(styles.wrapper, disabled && styles.disabled, className)}>
        {button}
        <span className={styles.label}>{label}</span>
      </label>
    )
  }

  return <div className={className}>{button}</div>
}
